export default "__VITE_ASSET__64005d4b__"